<template>
  <span
    class="float-right px-1.5 rounded text-xs leading-4 p-px"
    :class="[ item.isRefined ? 'text-EXPONDO-white bg-EXPONDO-primary-80' : 'bg-EXPONDO-grey-5' ]"
  >
    {{ item.count.toLocaleString() }}
  </span>
</template>

<script lang="ts">

import type { RefinementListItem } from 'vue-instantsearch/vue3/es';

export default defineComponent({
  name: 'FacetCount',
  props: {
    item: {
      type: Object as PropType<RefinementListItem>,
      required: true,
    },
  },
});

</script>
